import { render, staticRenderFns } from "./200807.vue?vue&type=template&id=f32e4540&scoped=true&"
import script from "./200807.vue?vue&type=script&lang=js&"
export * from "./200807.vue?vue&type=script&lang=js&"
import style0 from "./200807.vue?vue&type=style&index=0&id=f32e4540&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32e4540",
  null
  
)

export default component.exports